import { BaseModal } from './BaseModal'
import { SettingsToggle } from './SettingsToggle'
import {
  GAME_VERSION,
  HARD_MODE_DESCRIPTION,
  HIGH_CONTRAST_MODE_DESCRIPTION,
} from '../../constants/strings'

type Props = {
  isOpen: boolean
  handleClose: () => void
  isHardMode: boolean
  handleHardMode: Function
  isDarkMode: boolean
  handleDarkMode: Function
  isHighContrastMode: boolean
  handleHighContrastMode: Function
}

export const SettingsModal = ({
  isOpen,
  handleClose,
  isHardMode,
  handleHardMode,
  isDarkMode,
  handleDarkMode,
  isHighContrastMode,
  handleHighContrastMode,
}: Props) => {
  return (
    <BaseModal title="அமைப்புகள்" isOpen={isOpen} handleClose={handleClose}>
      <div className="flex flex-col mt-2 divide-y">
      <SettingsToggle
          settingName="கருமை நிலை"
          flag={isDarkMode}
          handleFlag={handleDarkMode}
        />
      <SettingsToggle
          settingName="உயர்முரண் நிலை"
          flag={isHighContrastMode}
          handleFlag={handleHighContrastMode}
          description={HIGH_CONTRAST_MODE_DESCRIPTION}
        />
        <SettingsToggle
          settingName="கடுமை நிலை"
          flag={isHardMode}
          handleFlag={handleHardMode}
          description={HARD_MODE_DESCRIPTION}
        />
      </div>
      <div className="flex mt-3 justify-center">
        <img
          src="https://omtamil.com/logo/soladle.png"
          width="100px"
          alt="OMTAMIL"
        ></img>
      </div>
      <small>
        <p className="flex mt-1 justify-center dark:text-gray-300">
          <small>
            பதிகை{GAME_VERSION}
          </small>
        </p>
      </small>
      <p className="flex justify-center mt-1 dark:text-gray-300">
        சொல் விளையாட்டு செயலி
      </p>
      <p className="mt-3 italic text-lg text-gray-500 dark:text-gray-300">
      'எழுத்து, சொல், பொருள்' <small>(தொல்காப்பியம்)</small>      </p>

      <h1 className="text-sm mt-6 grow font-bold flex underline justify-center dark:text-white">
        உருவாக்கமும் செயற்றிட்டமும்
      </h1>
      <div className="flex items-center justify-center mt-3 dark:text-white">
        <a href="https://twitter.com/muhelen" target="_blank" rel="noreferrer">
          <img
            src="https://omtamil.com/images/muhelen.png"
            width="50px"
            alt="MUHELEN"
          ></img>
        </a>
        <p className="flex justify-right text-sm text-gray-500 dark:text-gray-300">
          {' '}
          <a
            href="https://twitter.com/muhelen"
            target="_blank"
            rel="noreferrer"
            className="text-sm"
          >
            {' '}
            முகிலன் முருகன்<br></br>@muhelen
          </a>
        </p>
        <div className="mx-1"></div>
        <a
          href="https://twitter.com/mullairatha"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://omtamil.com/images/mullai.png"
            width="50px"
            alt="MULLAI"
          ></img>
        </a>
        <p className="flex justify-right text-sm text-gray-500 dark:text-gray-300">
          {' '}
          <a
            href="https://twitter.com/mullairatha"
            target="_blank"
            rel="noreferrer"
            className="text-sm"
          >
            {' '}
            முல்லை இராதா <br></br>@mullairatha
          </a>
        </p>
      </div>
      {/* <p className="text-sm mt-5 text-gray-500 dark:text-gray-300">
        {' '}
        <a
          href="https://www.nytimes.com/games/wordle/"
          target="_blank"
          rel="noreferrer"
          className="underline font-bold"
        >
          Wordle
        </a>{' '}
        <a
          href="https://github.com/omtamil/soladle"
          target="_blank"
          rel="noreferrer"
          className="underline font-bold"
        >
          திறமூல
        </a>{' '}
        நிரலில் மேம்படுத்தப்பட்டது
      </p> */}

      <p className="flex mt-5 justify-center dark:text-gray-300">
        <small>© 2012-2022 OMTAMIL DOTCOM (002135971-U)</small>
      </p>
    </BaseModal>
  )
}
